import { Pipe, PipeTransform } from '@angular/core';
import { Edition } from '@core/models/edition.model';

@Pipe({ name: 'premiumPack' })
export class PremiumPackPipe implements PipeTransform {

  transform(edition: Edition, premiumPackId: string | null) {
    return edition.premiumPacks.find((pack) => pack.id === premiumPackId);
  }
}
